import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
// import { withAuthenticator } from 'aws-amplify-react';

import Navbar from "./Navbar";
// import Body from "./Body";

class App extends Component {
  componentDidMount() {
    // var pattern = Trianglify({
    //   variance: 0.75,
    //   seed: "16xr6",
    //   x_colors: "random"
    // }).canvas();
    document.body.style.background =
      "linear-gradient(to bottom right, #1D2B64, #F8CDDA)";
  }

  render() {
    return (
      <div className="App">
        <Navbar />
      </div>
    );
  }
}

// export default withAuthenticator(App);
export default App;
